<template>
    <div>
        <bread-nav :assessment-cycle="assessmentCycle"
                   :facility-name="facilityName"
                   :classroom-name="classroomName"
                   :cycle-stage="cycleStage"
        ></bread-nav>

		<assessment-cycle-version-banner
			:assessment-cycle="assessmentCycle"
		></assessment-cycle-version-banner>

        <div v-if="sectionsUnavailable" class="row mb-2">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        Checking for available sections...
                        <br><br>
                        A section's indicators must be locked in the Initial Assessment before that section will appear here.
                    </div>
                </div>
            </div>
        </div><!-- .row -->
        <div class="row">
            <div class="col-3">
                <div class="card"
                     :class="{ 
                        'section-focus': generalComment == true
                     }"
                >
                    <div id="general_comment_card" class="card-body section-card d-flex justify-content-between" @click="showGeneralComment()">
                        General Comments
                    </div>
                </div>
                <div v-for="section in sections" :key="section.section_number">
                    <div v-if="lockedInitialSections[section.section_number]" 
                        class="card mt-2" 
                        :class="{ 'section-focus': section.section_number == activeSection.section_number }"
                    >
                        <div :id="'section_'+ section.section_number" class="card-body section-card d-inline-flex" @click="showActiveIndicators(section)">
                            <div>
                                {{ section.section_number }}.
                            </div>
                            <div class="pl-2 flex-grow-1">
                                {{ section.name }}
                            </div>
                            <div class="pl-2 my-auto">
                                <i v-if="lockedFollowupSections[section.section_number]" class="fas fa-lock"></i>
                                <i v-else-if="completeIndicatorsCount(section.section_number) == sectionIndicatorsCount(section.section_number)" class="fas fa-check-circle" style="color:#0fdd8b;"></i>
                                <i v-else-if="(completeIndicatorsCount(section.section_number) < sectionIndicatorsCount(section.section_number)) && (completeIndicatorsCount(section.section_number) != 0)" class="fas fa-adjust" style="color:#ef2c16;"></i>
                            </div>
                        </div>
                    </div><!-- .card -->
                </div>
            </div>
            <div v-if="!generalComment" id="indicator_list" class="col-9">
                <div v-if="activeSection.section_number">
                    <a :href="'/assessment-cycle/offline?assessment_cycle_id='+ cycle.id +'&stage=followup&section_number='+ activeSection.section_number" 
                        class="btn btn-primary btn-sm float-right"
                    >
                        Offline Form
                    </a>
                    <span class="section-title mr-3">{{ activeSection.section_number }}. &nbsp; {{ activeSection.name }}</span>
                    <a href=".collapse-all" id="toggle_details" data-toggle="collapse">toggle all details</a>
                </div>
                <div v-for="indicator in activeIndicators" :key="indicator.id">
                    <followup-indicator :indicator="indicator" :scoring-labels="scoringLabels"></followup-indicator>
                </div>
                <div v-if="activeSection.section_number" class="d-flex flex-column justify-content-center mt-4">
                    <div>
                        <ul>
                            <li>Indicator grades/comments are saved automatically as you input them</li>
                            <li>Lock Section is disabled until all indicators have been graded</li>
                        </ul>
                    </div>
                    <div>
                        <button v-if="!lockedFollowupSections[activeSection.section_number]" class="btn btn-primary ml-4" :disabled="gradedCount != activeIndicatorCount" @click="lockIndicators()">Lock Section</button>
                        <button v-if="canUnlockSection" class="btn btn-primary ml-4" @click="unlockIndicators()">Unlock Section</button>
                        <a :href="'/facilities/'+ cycle.facility_id" class="btn btn-secondary ml-4">Back to Facility Detail</a>
                    </div>
                </div>
            </div>
            <div v-if="generalComment" class="col-9">
                <div id="general_comment">
                    <general-comment
                        :assessment-cycle="assessmentCycle"
                        :assessment-type="cycleStage"
                    ></general-comment>
                </div>
            </div>
        </div><!-- .row -->
    </div>
</template>

<style scoped>
.section-card {
    cursor: pointer;
    padding: 1rem 1rem;
    line-height: 1.4;
}
.section-focus {
    border: 2px solid blue;
}
.section-title {
    font-size: 1.4em;
    font-weight: bold;
}
</style>

<script>
    import FollowupIndicator from '../indicators/FollowupIndicator'
    import BreadNav from '../breadcrumb_navbar/BreadNav'
    import GeneralComment from '../general_comment/GeneralComment'
    import AssessmentCycleVersionBanner from './AssessmentCycleVersionBanner.vue'    
    import { mapState } from 'vuex'

    export default {
        name: "Follow-up Assessment",

        components: { FollowupIndicator, BreadNav, GeneralComment, AssessmentCycleVersionBanner },

        props: {
            assessmentCycle: Object,
            facilityName: String,
            classroomName: String,
            scoringLabels: Object
        },

        data() {
            return {
                cycleStage: this.$options.name,
                activeIndicators: [],
                activeSection: {},
                generalComment: false
            }       
         },

        methods: {
            showGeneralComment () {
                this.generalComment = true
                this.activeSection = {}
            },
            showActiveIndicators (section) {
                this.generalComment = false
                this.activeSection = section
                this.activeIndicators = this.indicators[section.section_number]
            },
            lockIndicators () {
                let data = {
                    assessment_cycle_id: this.cycle.id,
                    section_number: this.activeSection.section_number
                }
                this.$store.dispatch('followup/lockIndicators', data)
            },
            unlockIndicators () {
                let data = {
                    assessment_cycle_id: this.cycle.id,
                    section_number: this.activeSection.section_number
                }
                this.$store.dispatch('followup/unlockIndicators', data)
            },
            sectionIndicatorsCount (section_number) {
                if (section_number) {
                    return this.indicators ? Object.keys(this.indicators[section_number]).length : -1
                }
            },
            completeIndicatorsCount (section_number) {
                let count = 0
                if (this.completeIndicators[section_number]) {
                    Object.values(this.completeIndicators[section_number]).forEach(val => {
                        if (val !== null && val.grade !== null) {
                            count++
                        }
                    });
                }
                return count
            },
            waitForCycle () {
                this.intervalId = setInterval(() => {
                    if (this.cycle) {
                        clearInterval(this.intervalId)
                        this.fetchData()
                    }
                }, 500)
            },
            fetchData () {
                this.$store.dispatch('cycle/fetchSections')
                this.$store.dispatch('cycle/fetchIndicators')
                this.$store.dispatch('initial/fetchInitialIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('followup/fetchFollowupIndicators', {
                    'assessment_cycle_id': this.cycle.id
                })
                this.$store.dispatch('general_comment/fetchGeneralComment', {'assessment_cycle_id': this.cycle.id, 'assessment_type': this.cycleStage})
            },
            formatDate (date) {
                return date ? moment(date).format('YYYY-MM-DD') : null
            }
        },

        computed: {
            ...mapState({
                cycle: state => state.cycle.cycle,
                sections: state => state.cycle.sections,
                indicators: state => state.cycle.indicators,
                authUserRoles: state => state.followup.authUserRoles,
                followupIndicators: state => state.followup.followupIndicators,
                lockedInitialSections: state => state.initial.sections.locked,
                lockedFollowupSections: state => state.followup.sections.locked,
                completeIndicators: state => state.followup.sections.indicatorsComplete,
                followupGeneralComment: state => state.general_comment.generalComment
            }),
            activeIndicatorCount () {
                return Object.keys(this.activeIndicators).length
            },
            gradedCount () {
                let graded = 0
                Object.values(this.followupIndicators[this.activeSection.section_number]).forEach(
                    indicator => {
                        (indicator.grade || indicator.grade === 0) ? graded++ : ''
                    }
                )
                return graded
            },
            sectionsUnavailable () {
                return Object.values(this.lockedInitialSections).includes(true) ? false : true
            },
            canUnlockSection () {
                return (this.authUserRoles.includes('Programmer') || this.authUserRoles.includes('Admin'))
                    && this.lockedFollowupSections[this.activeSection.section_number]
            } 
        },

        mounted () {
            this.$store.dispatch('cycle/setCycle', this.assessmentCycle)
            this.waitForCycle() // using this to overcome asynchrony
            this.$store.dispatch('followup/fetchAuthUserRoles')
        }
    }
</script>
